import { mutations } from './mutations'
import { actions } from './actions'

export const escala = {
  state: () => ({funcionarios: []}),
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/escalas/index.js